import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DestroyService } from '../../../../services/destroyservice';
import { SafeHtml, DomSanitizer } from '@angular/platform-browser';
import { HttpClient } from '@angular/common/http';
import { Utils } from '../../../../utils/utils';

@Component({
    selector: 'nvstruct-file-modal.component',
    standalone: false,
    templateUrl: './nvstruct-file-modal.component.html',
    styleUrls: ['./nvstruct-file-modal.component.less'],
    providers: [DestroyService]
})
export class NvstructFileModalComponent implements OnInit {
    fileContent: string | null = null;
    fileContentXML: SafeHtml | null = null;

    constructor(
        @Inject(MAT_DIALOG_DATA) public data: { xml: string; nvStructSchemaId: number; schemaVersion: string }
        , private readonly sanitizer: DomSanitizer
        , private readonly http: HttpClient
        , @Inject('BASE_URL') private readonly baseUrl: string) { }


ngOnInit(): void {
    this.fileContent = this.data.xml;
    // Safe to bypass sanitization: XML content is properly escaped before display
    this.fileContentXML = this.sanitizer.bypassSecurityTrustHtml(
        this.escapeXml(this.data.xml)
    );
}

    onCancel(): void { }

    escapeXml(xml: string): string {
        if (!xml) return '';
        return xml
            .replace(/&/g, '&amp;')
            .replace(/</g, '&lt;')
            .replace(/>/g, '&gt;');
    }

    downloadContent(): void {
        Utils.httpDownloadNVStructFile(this.http, this.baseUrl, this.data.nvStructSchemaId, (blob) => {
            const url = globalThis.URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.href = url;
            a.download = `nvstruct_${this.data.schemaVersion}.xml`;
            a.click();
            globalThis.URL.revokeObjectURL(url);
        });
    }
}